import React from 'react';

export default function UserManagement() {
  return (
    <div className="family-tree-container">
      <h1 className="page-title">User Management</h1>
      <p className="text-gray-600">Manage platform users from this section.</p>
    </div>
  );
}
